import { createSlice } from '@reduxjs/toolkit';
const slice = createSlice({
    name: 'idle',
    initialState: {
        idle: false,
        stale: false,
    },
    reducers: {
        idleDidEnter: (state) => {
            state.idle = true;
            state.stale = true;
        },
        idleDidLeave: (state) => {
            state.idle = false;
        },
        markStale: (state) => {
            state.stale = true;
        },
        markUpToDate: (state) => {
            state.stale = false;
        },
    },
});
export const { idleDidEnter, idleDidLeave, markStale, markUpToDate } = slice.actions;
export const idleReducer = slice.reducer;
